/* eslint-disable import/prefer-default-export */

export const DragTypes = {
  DOCUMENT: "document",
  NOTE_ANNOTATION: "note-annotation",
};
